<template>
  <dashboard-topbar/>
  <div class="main">
    <div class="mainContent">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-2 col-sm-2 col-2 pr-0">
            <dashboard-navbar/>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-10 col-sm-10 col-10 pl-0">
            <div class="cabinet-content">
              <div class="dashboard-heading">
                <h1>{{ $t('ReviewedProducts') }}</h1>
              </div>
              <dashboard-product-viewed-list/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardTopbar from "@/components/Topbar.vue";
import DashboardNavbar from "@/components/Navbar.vue"
import DashboardProductViewedList from "@/components/ProductViewedList.vue"

export default {
  name: 'DashboardApp',
  props: {
    msg: String,
  },
  components: {
    DashboardTopbar,
    DashboardNavbar,
    DashboardProductViewedList
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";

  .pr-0{
    padding-right: 0;
  }
  .pl-0{
    padding-left: 0;
  }
  .dashboard-heading{
    margin-top: 20px;
  }

  .main {
    margin-top: 86px;

    &Content {
      margin-top: 0;
    }

    .cabinet-content{
      min-height: 100vh;
      padding-left: 40px;
      border-left: 1px solid #e9e9e9;
      overflow: hidden;
      @media only screen and (max-width: $max-width-tablet) {
        padding-left: 12px;
      }
    }
  }
</style>
